import cuid from "cuid";
import { v4 as uuidv4 } from "uuid";
import { Dispatch } from "redux";
import { RootState } from "../reducers/store";
import packageJson from "../../package.json";

import { APP_NAME } from "../config";
const appVersion = packageJson.version;

export const createHttpHeaderWithAuthorization = (
    isXItemAccountant: boolean = false,
) => {
    return (dispatch: Dispatch, getState: () => RootState) => {
        const correlationId = uuidv4();
        const auth = getState().auth;
        const main = getState().main;
        const httpHeader = createHttpHeader(
            correlationId,
            main.accountantUuid,
            main.companyUuid,
            isXItemAccountant,
        );
        httpHeader["Authorization"] = `Bearer ${auth.token}`;
        httpHeader["X-User-ID"] = auth.id;
        return httpHeader;
    };
};

export function createHttpHeader(
    correlationId = uuidv4(),
    accountantUuid: string,
    companyUuid: string,
    isXItemAccountant: boolean,
) {
    return {
        "X-App-Name": APP_NAME || "",
        "X-App-Version": appVersion,
        "X-Request-ID": cuid(),
        "X-Correlation-ID": correlationId,
        "X-Item-ID":
            (isXItemAccountant
                ? accountantUuid
                    ? accountantUuid
                    : companyUuid
                : companyUuid) || "",
        "X-Manager-ID": accountantUuid || "",
        "Content-Type": "application/json;charset=utf-8",
        Accept: "application/json;charset=utf-8",
        "Accept-Language": "it-IT",
        Authorization: "",
        "X-User-ID": "",
    };
}
